import { createSelector } from 'reselect';

// Config
import {
  getSelectedDeliveryChoiceIdSelector,
} from '../../../redux/reducers/delivery/deliverySelector';
import { getGrandTotalRawSelector } from '../../../redux/reducers/order-form/orderFormSelector';

const deliveryChoiceTabsState = createSelector(
  [
    getGrandTotalRawSelector,
    getSelectedDeliveryChoiceIdSelector,
  ],
  (
    grandTotalRaw,
    selectedDeliveryChoiceId,
  ) => ({
    basketTotalValue: grandTotalRaw,
    selectedDeliveryChoiceId,
  }),
);

export default deliveryChoiceTabsState;
